<template>
    <b-form-select v-model="status" :options="STATUSES" style="width: 100%" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            status: ''
        };
    },

    computed: {
        ...mapGetters({ STATUSES: 'orders/ALL_STATUSES' })
    },

    watch: {
        value: {
            handler() {
                this.status = this.value;
            },
            immediate: true
        },

        status() {
            this.$emit('input', this.status);
        }
    }
};
</script>
